import React, { useState } from 'react';
import { Crown, MapPin } from 'lucide-react';

const mediaUrl = (url) => {
  if (!url) return null;
  if (url.startsWith('http') || url.startsWith('data:')) return url;
  return `${process.env.REACT_APP_BACKEND_URL || ''}${url}`;
};

const memberSince = (value) => {
  if (!value) return null;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  return date.toLocaleDateString('fr-CH', { month: 'long', year: 'numeric' });
};

const PremiumClientCard = ({ client }) => {
  const [imageFailed, setImageFailed] = useState(false);
  const photo = mediaUrl(client.profile_image);
  const isVip = client.plan === 'vip';
  const since = memberSince(client.member_since);

  return (
    <div
      className="flex flex-col items-center text-center bg-white rounded-2xl border border-rose-100 shadow-sm hover:shadow-lg transition-all p-4"
      data-testid="premium-client-card"
    >
      {photo && !imageFailed ? (
        <img
          src={photo}
          alt={client.pseudo}
          onError={() => setImageFailed(true)}
          className="w-20 h-20 rounded-full object-cover border-2 border-rose-200 mb-3"
        />
      ) : (
        <div className="w-20 h-20 rounded-full bg-rose-100 text-[#D4627F] text-2xl font-bold flex items-center justify-center mb-3">
          {(client.pseudo || '?').charAt(0).toUpperCase()}
        </div>
      )}

      <h3 className="font-semibold text-gray-900 text-sm truncate max-w-full">{client.pseudo}</h3>

      <span className="mt-1 inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-[11px] font-medium bg-rose-50 text-[#B84A66] border border-rose-200">
        <Crown className="w-3 h-3" />
        {isVip ? 'VIP' : 'Premium'}
      </span>

      {client.city && (
        <p className="flex items-center gap-1 text-xs text-gray-500 mt-2">
          <MapPin className="w-3 h-3" />
          {client.city}
        </p>
      )}
      {since && <p className="text-[11px] text-gray-400 mt-1">Membre depuis {since}</p>}
    </div>
  );
};

export default PremiumClientCard;
